export const WorkData = [
  {
    company: 'Agência OnTime',
    designation: 'Frontend - Freelancer',
    year: 2021,
    companyLogo: 'https://agenciaontime.com.br/img/logo.png',
    work: 'Desenvolvi toda a estrutura do site da empresa'
  }
]